import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBurningAccountSelector } from '../../ducks/main/selectors';
import { mainThunk } from '../../ducks/main/thunk';
import { bigIntDecimalsDivision } from '../../helpers/bignumber';
import { numberFormattingBigIntMultiply, numberFormattingBigIntSum } from '../../helpers/formats';
import { ThunkAppDispatch } from '../../store';

export const OfficialStatementJSON = () => {
  const burningAccount = useSelector(getBurningAccountSelector);
  const dispatch = useDispatch<ThunkAppDispatch>();

  useEffect(() => {
    dispatch(mainThunk());
  }, []);

  if (!burningAccount) return null;

  const balance = bigIntDecimalsDivision(burningAccount.balanceATM, 8);
  const burningBalance = numberFormattingBigIntSum('30000000000', balance);
  const newTotalSupply = numberFormattingBigIntMultiply(balance, '-1');

  return (
    <code className='json'>
      {JSON.stringify({
        'Initial Supply': '30000000000',
        'NXT Airdrop Jan 14, 2018': '3000000000',
        Burning: burningBalance,
        'New Total Supply': newTotalSupply,
        'Current Circulating Supply': 21165096531,
      })}
    </code>
  );
};
